import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  text: {
    textAlign: 'left',
    marginBottom: 10,
  },
});
